import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'

// Styles
import classes from './AdminPayment.scss'

// Actions
import { paymentActions, orderActions } from 'redux/actionCreators'

// Components
import { Heading, RadioButtonGroup, Searchbox, Pagination } from 'components'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

// Helpers
import _get from 'lodash.get'
import _isEqual from 'lodash.isequal'
import moment from 'moment'
import { query, pageFromProps } from 'helpers/utilities'

const SEARCH_BY_OPTIONS = [
  { title: 'รายการตามสถานะสั่งซื้อ', value: 'status' },
  { title: 'ตามเงื่อนไข', value: 'keyword' },
  { title: 'ค้นหาทุกรายการ', value: 'time' }
]

const STATUS_OPTIONS = [
  { title: 'รอชำระเงิน', value: 'pending' },
  { title: 'เครดิตลูกหนี้', value: 'credit' },
  { title: 'ชำระเงินแล้ว', value: 'paid' }
]

const mapStateToProps = (state) => ({
  payments: _get(state, ['payment', 'payments']),
  pageCount: _get(state, ['payment', 'pageCount']) || 0
})
const mapDispatchToProps = (dispatch) => ({
  attemptFindAllPayments: (payload) =>
    dispatch(paymentActions.attemptFindAllPayments(payload)),
  attemptSaveOrder: (payload) =>
    dispatch(orderActions.attemptSaveOrder(payload)),
  setInitial: () => dispatch({ type: 'SET_INITIAL' })
})

@connect(mapStateToProps, mapDispatchToProps)
class AdminPayment extends Component {
  static propTypes = {
    payments: PropTypes.array.isRequired,
    pageCount: PropTypes.number.isRequired,
    attemptFindAllPayments: PropTypes.func.isRequired
  };

  static contextTypes = {
    router: PropTypes.object.isRequired
  };

  constructor (props) {
    super(props)
    this.state = {
      startDate: query(props, 'startDate') ? moment(query(props, 'startDate'), 'YYYY-MM-DD') : undefined,
      endDate: query(props, 'endDate') ? moment(query(props, 'endDate'), 'YYYY-MM-DD') : undefined,
      initialPaymentStatuses: props.payments.reduce((statuses, payment) => ({ ...statuses, [payment.paymentId]: payment.orderStatus }), {}),
      paymentStatuses: props.payments.reduce((statuses, payment) => ({ ...statuses, [payment.paymentId]: payment.orderStatus }), {}),
      paymentEditedStates: props.payments.reduce((states, payment) => ({ ...states, [payment.paymentId]: false }), {})
    }
  }

  componentWillMount () {
    this.props.attemptFindAllPayments({
      status: query(this.props, 'status') === 'all' ? '' : query(this.props, 'status'),
      keyword: query(this.props, 'keyword'),
      startDate: query(this.props, 'startDate'),
      endDate: query(this.props, 'endDate')
    })
  }

  componentWillReceiveProps (nextProps) {
    if (!_isEqual(_get(this.props, ['location', 'query']), _get(nextProps, ['location', 'query']))) {
      nextProps.attemptFindAllPayments({
        status: query(nextProps, 'status') === 'all' ? '' : query(nextProps, 'status'),
        keyword: query(nextProps, 'keyword'),
        startDate: query(nextProps, 'startDate'),
        endDate: query(nextProps, 'endDate'),
        offset: (pageFromProps(nextProps) - 1) * 10
      })
      this.setState({
        startDate: query(nextProps, 'startDate') ? moment(query(nextProps, 'startDate'), 'YYYY-MM-DD') : undefined,
        endDate: query(nextProps, 'endDate') ? moment(query(nextProps, 'endDate'), 'YYYY-MM-DD') : undefined
      })
    } else if (!_isEqual(this.props.payments, nextProps.payments)) {
      this.setState({
        initialPaymentStatuses: nextProps.payments.reduce((statuses, payment) => ({ ...statuses, [payment.paymentId]: payment.orderStatus }), {}),
        paymentStatuses: nextProps.payments.reduce((statuses, payment) => ({ ...statuses, [payment.paymentId]: payment.orderStatus }), {}),
        paymentEditedStates: nextProps.payments.reduce((states, payment) => ({ ...states, [payment.paymentId]: false }), {})
      })
    }
  }

  _onSearchByChange = (searchBy) => {
    this.context.router.push(`${_get(this.props, ['location', 'pathname'])}?searchBy=${searchBy}`)
  }

  _onStatusChange = (status) => {
    this.context.router.push(`${_get(this.props, ['location', 'pathname'])}?searchBy=status&status=${status}`)
  }

  _onEditStatus = (paymentId) => {
    this.setState({ paymentEditedStates: this.state.paymentEditedStates.merge({ [paymentId]: true }) })
  }

  _onSaveStatus = (paymentId, orderId) => {
    this.props.attemptSaveOrder({ orderId, paidStatus: this.state.paymentStatuses[paymentId] })
  }

  _onCancelStatus = (paymentId) => {
    this.setState({
      paymentStatuses: this.state.paymentStatuses.merge({ [paymentId]: this.state.initialPaymentStatuses[paymentId] }),
      paymentEditedStates: this.state.paymentEditedStates.merge({ [paymentId]: false })
    })
  }

  _onDateChange = (dateField, value) => {
    this.setState({ [dateField]: value })
  }

  _onSearch = () => {
    this.context.router.push(`${_get(this.props, ['location', 'pathname'])}?searchBy=time&startDate=${this.state.startDate.format('YYYY-MM-DD')}&endDate=${this.state.endDate.format('YYYY-MM-DD')}`)
  }

  _onMouseEnter = (paymentId) => { this.setState({ [`${paymentId}Hovered`]: true }) }
  _onMouseLeave = (paymentId) => { this.setState({ [`${paymentId}Hovered`]: false }) }

  _renderRow = ({ paymentId, orderId, createdAt, paymentDate, paymentTime, accountNumber, deliveryName, deliveryContactNumber, imagePath, amount }) =>
    <tr key={paymentId}>
      <td>{orderId}</td>
      <td>{moment(createdAt).format('DD-MM-YYYY')}</td>
      <td>{moment(createdAt).format('HH:mm')}</td>
      <td className='text-left'>
        <div>{deliveryName}</div>
        <div>{deliveryContactNumber}</div>
      </td>
      <td className='text-left'>
        <div>
          <span className={classes.colLeft}>บัญชีที่โอนเงิน</span>
          <span className={classes.colRight}>{accountNumber}</span>
        </div>
        <div>
          <span className={classes.colLeft}>วันที่ชำระเงิน</span>
          <span className={classes.colRight}>{paymentDate}</span>
        </div>
        <div>
          <span className={classes.colLeft}>เวลา (โดยประมาณ)</span>
          <span className={classes.colRight}>{paymentTime}</span>
        </div>
        <div>
          <span className={classes.colLeft}>จำนวนเงิน</span>
          <span className={classes.colRight}>{amount} บาท</span>
        </div>
        <a href={imagePath} className={classes.btnViewSlip}
          onMouseEnter={() => this._onMouseEnter(paymentId)}
          onMouseLeave={() => this._onMouseLeave(paymentId)}>
          <img src='/images/icon-camera.png' role='presentation' />
          <span>ดูรูปสลิป</span>
        </a>
        <div className={`${classes.imageBox} ${this.state[`${paymentId}Hovered`] && classes.active}`}>
          <img className={classes.thumbnail} src={imagePath} alt='thumbnail' />
        </div>
      </td>
      <td className={classes.editor}>
        <RadioButtonGroup radioClassName={classes.radioButtonGroup}
          disabled={!this.state.paymentEditedStates[paymentId]}
          name={`${paymentId}.status`}
          selectedValue={this.state.paymentStatuses[paymentId]}
          onChange={(status) => this.setState({ paymentStatuses: this.state.paymentStatuses.merge({ [paymentId]: status }) })}
          options={STATUS_OPTIONS} />
        <div className={classes.buttonGroup}>
          <div className={classes.row}>
            <div className={classes.col} />
            <div className={classes.col}>
              {this.state.paymentEditedStates[paymentId] && (
                <div onClick={() => this._onSaveStatus(paymentId, orderId)}>
                  <img className={classes.save} src='/images/icon-disk-orange.png' alt='icon-save' />
                  <span>บันทึก</span>
                </div>
              )}
            </div>
          </div>
          <div className={classes.row}>
            <div className={classes.col}>
              {!this.state.paymentEditedStates[paymentId] && this.state.paymentStatuses[paymentId] !== 'delivered' && (
                <div onClick={() => this._onEditStatus(paymentId)}>
                  <img className={classes.edit} src='/images/icon-pencil-orange.png' alt='icon-edit' />
                  <span>แก้ไข</span>
                </div>
              )}
            </div>
            <div className={classes.col}>
              {this.state.paymentEditedStates[paymentId] && (
                <div onClick={() => this._onCancelStatus(paymentId)}>
                  <img className={classes.delete} src='/images/icon-bin-orange.png' alt='icon-delete' />
                  <span>ยกเลิก</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </td>
    </tr>

  render () {
    const { payments, pageCount, location } = this.props
    return (
      <section className={classes.payment}>
        <Heading>ค้นหา</Heading>
        <div className='text-center'>
          <RadioButtonGroup name='searchBy'
            selectedValue={query(this.props, 'searchBy') || 'status'}
            onChange={this._onSearchByChange}
            options={SEARCH_BY_OPTIONS} />
        </div>
        <div className='search-box'>
          {(query(this.props, 'searchBy') || 'status') === 'status' && (
            <RadioButtonGroup name='status'
              selectedValue={query(this.props, 'status') || 'all'}
              onChange={this._onStatusChange}
              options={[{ title: 'ทั้งหมด', value: 'all' }].concat(STATUS_OPTIONS)} />
          )}
          {query(this.props, 'searchBy') === 'keyword' && (
            <Searchbox description='ค้นหาสินค้าได้จาก เลขที่บิล ชื่อ เบอร์โทรติดต่อ'
              keyword={query(this.props, 'keyword')}
              onSearch={(keyword) => this.context.router.push(`${_get(this.props, ['location', 'pathname'])}?searchBy=keyword&keyword=${keyword}`)} />
          )}
          {query(this.props, 'searchBy') === 'time' && (
            <div className='time-range-selector'>
              <span>ข้อมูลระหว่าง วันที่</span>
              <div className='date-picker-container'>
                <DatePicker dateFormat='DD-MM-YYYY' selected={this.state.startDate} onChange={(date) => this._onDateChange('startDate', date)} />
                <img className='calendar' src='/images/icon-calendar-orange.png' role='presentation' />
              </div>
              <span style={{ marginLeft: '15px' }}>ถึง</span>
              <div className='date-picker-container'>
                <DatePicker dateFormat='DD-MM-YYYY' selected={this.state.endDate} onChange={(date) => this._onDateChange('endDate', date)} />
                <img className='calendar' src='/images/icon-calendar-orange.png' role='presentation' />
              </div>
              <div className='btn-time-range-search' onClick={this._onSearch}>
                <img src='/images/icon-search-white.png' alt='icon-search-white' />
              </div>
            </div>
          )}
        </div>
        <Pagination router={this.context.router} location={location} pageCount={pageCount} />
        <table>
          <thead>
            <tr>
              <td>เลขที่การสั่งซื้อ</td>
              <td>วันที่</td>
              <td>เวลา</td>
              <td>ข้อมูลลูกค้า</td>
              <td>รายละเอียด</td>
              <td>สถานะ</td>
            </tr>
          </thead>
          <tbody>
            {payments.map(this._renderRow)}
            {!payments.length && <tr><td className='text-center' colSpan='6'>ยังไม่มีการแจ้งโอนเงิน</td></tr>}
          </tbody>
        </table>
        <Pagination router={this.context.router} location={location} pageCount={pageCount} />
      </section>
    )
  }
}

export default AdminPayment



// WEBPACK FOOTER //
// ./src/containers/Admin/AdminPayment/AdminPayment.js